export class CleanupEvents {
  static cleanupRequest = 'cleanupRequest';
  static mainModuleDestroyedNotification = 'mainModuleDestroyedNotification';
  static signoutCompleted = 'signoutCompletedNotification';
  static resetSignout = 'resetSignout';
};
